/** Cooperative Pause/Cancel request while a task is Processing. */
export default Object.freeze({
  None: 0,
  Pause: 1,
  Cancel: 2,
});
